import React, { useEffect, useImperativeHandle, useRef } from 'react';

import { format2TimeStamp } from '@/utils/date';
import { IMyFormRef } from '@/components/CustomForm';
import { filterFormParams } from '@/utils/transform';

import FilterForm from './Filter';
import SearchForm from './Search';

import styles from './index.module.scss';

export interface SearchFormRef {
  getFormValue: () => any;
}

enum QueryTypeEnum {
  Filter,
  Search,
}

interface IProps {
  innerRef: React.Ref<SearchFormRef>;
  defaultValue: any;
  onChange: () => void;
  onExport: () => void;
}

const Index: React.FC<IProps> = (props) => {
  const filterFormRef = useRef<IMyFormRef>();
  const searchFormRef = useRef<IMyFormRef>();
  const queryTypeRef = useRef<QueryTypeEnum>(QueryTypeEnum.Filter);

  const { innerRef, defaultValue, onChange, onExport } = props;

  // 筛选、搜索值
  const getQueryFormValue = () => {
    if (queryTypeRef.current === QueryTypeEnum.Filter) {
      searchFormRef.current.resetFields();
      const searchValue: any = filterFormParams(filterFormRef.current.getFieldsValue());
      if (searchValue.operationDate) {
        searchValue.startDateTime = format2TimeStamp(searchValue.operationDate[0]);
        searchValue.endDateTime = format2TimeStamp(searchValue.operationDate[1]);
      }
      delete searchValue.operationDate;
      return searchValue;
    }

    if (queryTypeRef.current === QueryTypeEnum.Search) {
      filterFormRef.current.resetFields();
      return filterFormParams(searchFormRef.current.getFieldsValue());
    }
    return {};
  };

  // 筛选
  const handleFilterSubmit = () => {
    queryTypeRef.current = QueryTypeEnum.Filter;
    // 重置搜索表单
    searchFormRef.current.resetFields();
    onChange();
  };

  // 搜索
  const handleSearchSubmit = () => {
    queryTypeRef.current = QueryTypeEnum.Search;
    // 重置筛选表单
    filterFormRef.current.resetFields();
    onChange();
  };

  // 重置
  const handleSearchReset = () => {
    queryTypeRef.current = null;
    // 重置表单数值
    filterFormRef.current.resetFields();
    searchFormRef.current.resetFields();
    onChange();
  };

  useImperativeHandle(
    innerRef,
    () => ({
      getFormValue: getQueryFormValue,
    }),
    [],
  );

  useEffect(() => {
    filterFormRef.current.setFieldsValue(defaultValue);
    searchFormRef.current.setFieldsValue(defaultValue);
  }, []);

  return (
    <div className={styles.formContainer}>
      <FilterForm formRef={filterFormRef} onFilter={handleFilterSubmit} />
      <SearchForm
        formRef={searchFormRef}
        onSearch={handleSearchSubmit}
        onReset={handleSearchReset}
        onExport={onExport}
      />
    </div>
  );
};

export default Index;
